import { makeMutable, type SharedValue } from 'react-native-reanimated'

/**
 * Window-space Y coordinate of the game bottom sheet's top edge, kept in sync
 * by the sheet itself through the `animatedPosition` prop (only the post-hand
 * ShowCards drawer is wired up to it).
 *
 * While that drawer is presented, the value tracks its top edge as it opens,
 * drags and closes. `Infinity` means "no drawer presented".
 *
 * Consumers (e.g. the advisor speech bubble in ActionAdvisorCard) use it to
 * slide up and down with the drawer so they stay pinned just above its top
 * edge instead of being covered by it.
 */
export const gameSheetTopY: SharedValue<number> = makeMutable(Number.POSITIVE_INFINITY)
